document.addEventListener("DOMContentLoaded", async function(){
  const nutritionAccordian = document.querySelector('.left_container.ingredients .nutrition_container');
    nutritionAccordian.addEventListener('click',() => {
    nutritionAccordian.querySelector('.angle-above-svg').classList.toggle('rotate');
    nutritionAccordian.nextElementSibling.classList.toggle('hidden');
  })
  const urls = new URLSearchParams(window.location.search);
  const language = window.location.pathname.startsWith("/fr") ? "fr" : "en";

  let id = document.querySelector('.recipe-id').dataset.recipeMetaobjectId;
  if(!id) id = urls.get("id");

  const requestOptions = {
  method: "GET",
  redirect: "follow"
};

  // redirect to recipe page when banana split recipe appear recipe id 95195 and 95148
  if(id == 95195 || id == 95148) window.location.href = '/pages/breyers-recipe-page';
  
  const response = await fetch(`https://www.myindiabazar.com/ensenterprises/ichub/getProductDetails.php?recipeId=${id}&lang=${language}`, requestOptions);
  const result = await response.json();
  const recipePageUrl = new URL(window.location.href)
  if(result.hits && result.hits.total.value > 0){
      const recipes = result.hits.hits;
      const recipe = recipes.find((r) => r._id == id);
      if (recipe) {
        const recipeData = recipe._source.recipeData;
        document.getElementById("recipe-name").textContent = recipeData.name;
        
        if(document.querySelector('.recipe_name_breadcrum')) document.querySelector('.recipe_name_breadcrum').textContent = recipeData.name;
        document.getElementById("recipe-image").src = recipeData.newImage[0].default.url;
        document.getElementById("recipe-image").alt = recipeData.newImage[0].default.title;
        document.getElementById("recipe-image").title = recipeData.newImage[0].default.title;
        recipePageUrl.searchParams.set('name', recipeData.name.replaceAll(' ','-').toLowerCase());
        window.history.replaceState({},'',recipePageUrl);
        document.getElementById("prep-time").textContent = recipeData.prepTime.replace('PT','').replace('M',' min');
        document.getElementById("total-time").textContent = recipeData.totalTime.replace('PT',"").replace("M"," min");
        document.getElementById("total-rank").textContent = recipeData.rank;
        document.querySelector('.left_container.ingredients .ingedients_item_list').innerHTML = recipeData?.recipeIngredient?.[0]?.itemListElement?.map(list => `<li>${list}</li>`).join('') || '';
        const nutritionData = recipeData.nutritionalInformation.nutritionPerRecipe;
        const nutritionList = document.querySelector('.left_container.ingredients .nutrition_classification');
        nutritionList.innerHTML = Object.keys(nutritionData).reduce((html, key) => {
          const { value, unitCode } = nutritionData[key];
          return html + `<li><span class="minerals_name">${key.replace('PerNutrientBasis', '')}</span><span class="minerals_value">${value} ${unitCode}</span></li>`;
        }, ''); 
        // document.querySelector('.right_container.ingredients .instructions .instructions_detailings').textContent = recipeData.recipeInstructions[0].itemListElement.map(line => line.text);
        document.querySelector('.right_container.ingredients .instructions').innerHTML = recipeData.recipeInstructions?.[0]?.itemListElement.map(line => `<li>${line.text}</li>`).join('') || "";
        document.querySelector('.right_container.ingredients .ingredients_sub_image').src = recipeData.newImage?.[0]?.default.url || '';
        document.querySelector('.right_container.ingredients .ingredients_sub_image').alt = recipeData.newImage?.[0]?.default.title || "";
        document.querySelector('.right_container.ingredients .ingredients_sub_image').title = recipeData.newImage?.[0]?.default.title || "";

      // Featured Recipe API
      const productID = recipeData.relatedProductCodes;
      if(productID != 'NULL'){
        // Show Featured Product
        const close_Flavor_Btn = document.getElementById('closeBtn');
        const flavour_pop_up_form = document.querySelector('.flavour_pop_up_form');
          close_Flavor_Btn.addEventListener('click', function () {
            flavour_pop_up_form.classList.add('hidden');
          });
          setTimeout( function(){
            flavour_pop_up_form.classList.remove('hidden');
         },1000)
        const featureRecipe = await fetch(`https://www.myindiabazar.com/ensenterprises/ichub/relatedProducts.php?pid=${productID}`);
        const relatedProductData = await featureRecipe.json();
        const relatedProductFeaturedImage = document.querySelector('#flavour_pop_up_form .popup_img');
        const relatedProductTitle = document.querySelector('#flavour_pop_up_form .product_title');
        const relatedProductHref = document.querySelector('#flavour_pop_up_form .flavor_buy_now a');
        relatedProductFeaturedImage.src = relatedProductData.data.product.featuredMedia.preview.image.url;
        relatedProductTitle.textContent = relatedProductData.data.product.title;
        relatedProductHref.href = `/products/${relatedProductData.data.product.handle}`;
      }
      } else {
        console.error("Recipe not found");
      }
  }else{
    console.log('Not able to fetch data')
  }

  // Similar Products Sections
  let size = 5;
  async function fetchSimilarRecipes() {
      const data = await fetch(`https://www.myindiabazar.com/ensenterprises/ichub/similarProducts.php?lang=en&form=0&size=${size}&recipeId=${id}`, requestOptions);
      const output = await data.json();

      if(output.hits && output.hits.total.value <= 0){
        document.querySelector('.more_recipes').classList.add('hidden');
        return;
      }

      if (output.hits && output.hits.total.value > 0) {
          const total_similar_product = output.hits.total.value;
          const recipes = output.hits.hits;
          const similarRecipes = recipes.map(item => item._source.recipeData);

          if (similarRecipes.length > 0) {
            document.querySelector('.more_recipes .more_recipes_images').innerHTML = similarRecipes.map((rec, index) => {
              const extraClass = (similarRecipes.length >= 6 && index === 0) ? 'fix_height' : '';
              return `
                <a class="${extraClass} redirect_blog" aria-label="${index + 1} of ${total_similar_product}" href="/pages/breyers-recipe-detailed?id=${output.hits.hits[index]._id}">
                  <div class="try_more_img_layers">
                    <img src="${rec.newImage?.[0]?.default?.url}" title="${rec.newImage?.[0]?.default?.title}" alt="${rec.newImage?.[0]?.default?.title}" />
                    <span class="try_more_product_title">${rec.newImage?.[0]?.default?.title}</span>
                  </div>
                </a>`;
            }).join('');
          }
      }
  }
  fetchSimilarRecipes();

  document.querySelector('.more_recipes .load_more_recipe').addEventListener('click', () => {
      size += 5; 
      fetchSimilarRecipes();
  });

})